<template>
    <div class="hello">
        <h3 v-on:click="return_to_cats()">{{ title }}</h3>
        <section v-if="errored">
            <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
        </section>
        <div v-if="loading" class="loading"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>

        <transition name="fade">
        <div id='resulttarget' v-if="(showBrandProducts && !loading)" class="productResults clearfix">
            <div class="resultsblock">
                <div class="row alphabrandpager cf" v-if="brand_id == 0">
                    Find results with brand names starting with:
                    <select v-model="alphaselect" name="alpha" class="alpha"
                            v-on:change="page = 1; get_brandproducts_by_alpha(alphaselect)">
                        <option value="">All</option>
                        <option value="A">A</option>
                        <option value="B">B</option>
                        <option value="C">C</option>
                        <option value="D">D</option>
                        <option value="E">E</option>
                        <option value="F">F</option>
                        <option value="G">G</option>
                        <option value="H">H</option>
                        <option value="I">I</option>
                        <option value="J">J</option>
                        <option value="K">K</option>
                        <option value="L">L</option>
                        <option value="M">M</option>
                        <option value="N">N</option>
                        <option value="O">O</option>
                        <option value="P">P</option>
                        <option value="Q">Q</option>
                        <option value="R">R</option>
                        <option value="S">S</option>
                        <option value="T">T</option>
                        <option value="U">U</option>
                        <option value="V">V</option>
                        <option value="W">W</option>
                        <option value="X">X</option>
                        <option value="Y">Y</option>
                        <option value="Z">Z</option>
                    </select>
                </div>

                <!-- todo: modularize this -->
                <div class="pager row" v-if="(meta != null) && (processedBrandProducts.length > 1)">
                    <span class="pagerdetails medium-12 large-4 columns">&nbsp;</span>

                    <div class="pagercontrols medium-4 large-4 columns">
                        <span v-if="(meta.current_page != 1)" class="paginationbox active"><a v-on:click="previous_page()"><i class="fa fa-angle-double-left"></i> Previous</a></span>
                        <span v-if="(page < meta.last_page)" class="paginationbox active"><a v-on:click="next_page()">Next <i class="fa fa-angle-double-right"></i> </a></span>
                    </div>

                    <div class="pagerdetails medium-4 large-4 columns">
				            (Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} brands)
                    </div>
                </div>

                <BrandWithProducts
                        v-for="brandproduct in processedBrandProducts" v-bind:key="brandproduct.id"
                        v-bind:brandproduct="brandproduct" v-bind:totalshown="processedBrandProducts.length"
                />

                <div class="pager row" v-if="(meta != null) && (processedBrandProducts.length > 1)">
                    <span class="pagerdetails medium-12 large-4 columns">&nbsp;</span>

                    <div class="pagercontrols medium-4 large-4 columns">
                        <span v-if="(meta.current_page != 1)" class="paginationbox active"><a v-on:click="previous_page()"><i class="fa fa-angle-double-left"></i> Previous</a></span>
                        <span v-if="(page < meta.last_page)" class="paginationbox active"><a v-on:click="next_page()">Next <i class="fa fa-angle-double-right"></i> </a></span>
                    </div>

                    <div class="pagerdetails medium-4 large-4 columns">
                        (Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} brands)
                    </div>
                </div>

            </div>
        </div>
        </transition>
    </div>



</template>

<script>
    import BrandWithProducts from './BrandWithProducts.vue'
    import ApiService from '../services/ApiService';

    export default {
        name: 'Brands',
        components: {
            BrandWithProducts
        },
        props: {
            brand_id: 0
        },
        data() {
            return {
                alphaselect: '',
                title: "Brands",
                brandProducts: [],
                info: null,
                loading: true,
                errored: false,
                showBrandProducts: true,
                page: 0,
                meta: null
            }
        },
        created() {
            console.log('created');
            if (this.brand_id != 0) {
                ApiService.getBrandproductsById(this.brand_id)
                    .then(response => (this.brandProducts = response.data))
                    .then(response => (this.meta = response.meta))
                    .catch(error => {
                        console.log(error);
                        this.errored = true
                    })
                    .finally(() => {
                        this.showBrandProducts = true;
                        this.loading = false;
                    })
            } else {
                ApiService.getBrandproducts(this.page)
                    .then(response => (this.brandProducts = response.data))
                    .then(response => (this.meta = response.meta))
                    .catch(error => {
                        console.log(error);
                        this.errored = true
                    })
                    .finally(() => {
                        this.showBrandProducts = true;
                        this.loading = false;
                    })
            }
        },
        methods: {
            get_brandproducts() {
                this.loading = true;
                this.title = 'Brands';
                this.meta = null;
                ApiService.getBrandproducts(this.page)
                    .then(response => (this.brandProducts = response.data))
                    .then(response => (this.meta = response.meta))
                    .catch(error => {
                        console.log(error);
                        this.errored = true
                    })
                    .finally(() => {
                        this.showBrandProducts = true;
                        this.loading = false;
                    })
            },
            get_brandproducts_by_alpha(alphaselect) {
                if (alphaselect == '') {
                    this.get_brandproducts();
                } else {
                    this.loading = true;
                    this.meta = null;
                    this.title = 'Brands starting with "' + alphaselect + '"';
                    ApiService.getBrandproductsByAlpha(alphaselect, this.page)
                        .then(response => (this.brandProducts = response.data))
                        .then(response => (this.meta = response.meta))
                        .catch(error => {
                            console.log(error);
                            this.errored = true
                        })
                        .finally(() => {
                            this.showBrandProducts = true;
                            this.loading = false;
                        })
                }
            },
            previous_page() {
                this.page--;
                this.get_brandproducts_by_alpha(this.alphaselect);
            },
            next_page() {
                this.page++;
                this.get_brandproducts_by_alpha(this.alphaselect);
            }
        },
        computed: {
            processedBrandProducts() {
                if ('undefined' != this.brandProducts) {
                    let brandProducts = this.brandProducts.data;
                    // console.log('here', brandProducts);
                    return brandProducts;
                } else {
                    return [];
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h3 {
        font-size: 24px;
        font-weight: 500;
        margin: 40px 0 0;
    }

    h5 a {
        color: #555;
    }


    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .alphabrandpager {
        text-align: center !important;
        padding: .5em 0;
    }
</style>
